/**
 * Put focus back on the previously focused active element if
 * this element or any of its children have focus / are active
 * @param htmlElementContainer HTMLElement container that has active element
 * @param lastFocusedHtmlElement Last HTMLElement that was active / focused
 */
export var maybeFocusLastHtmlElement = function (htmlElementContainer, lastFocusedHtmlElement) {
    if (htmlElementContainer &&
        htmlElementContainer.contains(document.activeElement)) {
        if (lastFocusedHtmlElement) {
            lastFocusedHtmlElement.focus();
        }
        else {
            htmlElementContainer.blur();
        }
    }
};
//# sourceMappingURL=maybeFocusLastHtmlElement.js.map